import RiskScoreFilter from "security-app/components/SecurityEvents/Alerts/RiskScoreFilter";
import { commonEventAttributes } from "components/events/Constants";
export const INVESTIGATION_EVENTS_LIST_ID = "investigationEventList";
export const ATTRIBUTES = [
  ...commonEventAttributes,
  {
    id: "scores",
    title: "Risk Score",
    type: "STRING",
    sortable: true,
    filterable: true,
    sliceable: true,
    filter_component: RiskScoreFilter
  }
];
export const listElements = {
  defaultLayout: {
    entityTableId: INVESTIGATION_EVENTS_LIST_ID,
    defaultPageSize: 10,
    defaultSort: { attributeId: "scores", direction: "desc" },
    defaultDisplayedAttributes: ["message", "scores", "timestamp"],
    defaultColumnOrder: ["message", "scores", "timestamp"]
  }
};
